__turbopack_export_value__({
  "body-logo-18": "DocumentItem-module-scss-module__E8Duwa__body-logo-18",
  "body-text-12": "DocumentItem-module-scss-module__E8Duwa__body-text-12",
  "body-text-14": "DocumentItem-module-scss-module__E8Duwa__body-text-14",
  "body-text-16": "DocumentItem-module-scss-module__E8Duwa__body-text-16",
  "body-text-18": "DocumentItem-module-scss-module__E8Duwa__body-text-18",
  "body-text-20": "DocumentItem-module-scss-module__E8Duwa__body-text-20",
  "body-text-24": "DocumentItem-module-scss-module__E8Duwa__body-text-24",
  "body-text-24-2": "DocumentItem-module-scss-module__E8Duwa__body-text-24-2",
  "body-text-heading-2": "DocumentItem-module-scss-module__E8Duwa__body-text-heading-2",
  "body-text-heading-3": "DocumentItem-module-scss-module__E8Duwa__body-text-heading-3",
  "body-text-medium-14": "DocumentItem-module-scss-module__E8Duwa__body-text-medium-14",
  "body-text-medium-16": "DocumentItem-module-scss-module__E8Duwa__body-text-medium-16",
  "body-text-medium-18": "DocumentItem-module-scss-module__E8Duwa__body-text-medium-18",
  "body-text-medium2-18": "DocumentItem-module-scss-module__E8Duwa__body-text-medium2-18",
  "body-text2-14": "DocumentItem-module-scss-module__E8Duwa__body-text2-14",
  "body-text2-16": "DocumentItem-module-scss-module__E8Duwa__body-text2-16",
  "button-primary-text": "DocumentItem-module-scss-module__E8Duwa__button-primary-text",
  "button-text": "DocumentItem-module-scss-module__E8Duwa__button-text",
  "button2-text": "DocumentItem-module-scss-module__E8Duwa__button2-text",
  "card-shadow": "DocumentItem-module-scss-module__E8Duwa__card-shadow",
  "document": "DocumentItem-module-scss-module__E8Duwa__document",
  "document__button": "DocumentItem-module-scss-module__E8Duwa__document__button",
  "document__inner": "DocumentItem-module-scss-module__E8Duwa__document__inner",
  "document__text": "DocumentItem-module-scss-module__E8Duwa__document__text",
  "effect-menu": "DocumentItem-module-scss-module__E8Duwa__effect-menu",
  "header-1": "DocumentItem-module-scss-module__E8Duwa__header-1",
  "main-container": "DocumentItem-module-scss-module__E8Duwa__main-container",
  "main-footer-container": "DocumentItem-module-scss-module__E8Duwa__main-footer-container",
  "main-header-container": "DocumentItem-module-scss-module__E8Duwa__main-header-container",
  "txt-12-bold": "DocumentItem-module-scss-module__E8Duwa__txt-12-bold",
  "txt-14-bold": "DocumentItem-module-scss-module__E8Duwa__txt-14-bold",
  "txt-14-bold-caps": "DocumentItem-module-scss-module__E8Duwa__txt-14-bold-caps",
  "txt-14-med": "DocumentItem-module-scss-module__E8Duwa__txt-14-med",
  "txt-16-bold": "DocumentItem-module-scss-module__E8Duwa__txt-16-bold",
  "txt-16-med": "DocumentItem-module-scss-module__E8Duwa__txt-16-med",
  "txt-18-bold": "DocumentItem-module-scss-module__E8Duwa__txt-18-bold",
  "txt-18-medium": "DocumentItem-module-scss-module__E8Duwa__txt-18-medium",
  "txt-18-medium-24": "DocumentItem-module-scss-module__E8Duwa__txt-18-medium-24",
  "txt-24-semi": "DocumentItem-module-scss-module__E8Duwa__txt-24-semi",
});
